const loadCardsSelectionPage = () =>
  import("@/pages/cards-selection").then((m) => ({ default: m.CardsSelection }));

const loadAnalysisPage = () =>
  import("@/pages/analysis-page").then((m) => ({ default: m.AnalysisPage }));

export function prefetchDrawPage() {
  void loadCardsSelectionPage();
}

export function prefetchReadingPage() {
  void loadAnalysisPage();
}

export { loadCardsSelectionPage, loadAnalysisPage };
